import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { updateIsSponsored } from '../../../../services/wire/edit-services';

export default class SponsorshipControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    wasSponsored: PropTypes.bool.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      isSponsored: this.props.wasSponsored,
    };
  }

  handleIsSponsoredChange(evt) {
    const isSponsored = evt.target.value === 'true';

    this.loading.start();
    updateIsSponsored(this.props.wireId, isSponsored)
      .then(() => {
        this.setState({ isSponsored });
        postal.publish({
          channel: 'editor',
          topic: 'is-sponsored-changed',
          data: isSponsored,
        });
      })
      .catch(e => defaultOnErrorHandler(e, 'Error updating sponsorship status'))
      .finally(() => this.loading.stop());
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <form className="--user-facing">
            <section className="form-group">
              <span className="sidebar-item-desc">Is this a sponsored wire?</span>
              <label htmlFor="sponsored-yes" className="sidebar-item-radio-group">
                <input
                  id="sponsored-yes"
                  type="radio"
                  value
                  checked={this.state.isSponsored}
                  onChange={e => this.handleIsSponsoredChange(e)}
                />
                Yes
              </label>
              <label htmlFor="sponsored-no" className="sidebar-item-radio-group">
                <input
                  id="sponsored-no"
                  type="radio"
                  value={false}
                  checked={!this.state.isSponsored}
                  onChange={e => this.handleIsSponsoredChange(e)}
                />
                No
              </label>
              <Loading variant="sip" ref={el => (this.loading = el)} />
            </section>
          </form>
        </aside>
      </ErrorBoundary>
    );
  }
}
